/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

import { React, useState } from 'react';
import Header from "./Header";
import packageJson from "../../../package.json";
import Footer from "./Footer";
import DataContainer from "../DataContainer";
import CareCheckIn from "../carecheckin/CareCheckIn";

export default function Body(props) {
    // The name configured within package.json conforms to a regular expression
    // pattern that dictates that the first letter be lower-cased. The following
    // capitalizes the first letter of the name.
    const applicationName = packageJson.name.charAt(0).toUpperCase() + packageJson.name.slice(1);

    const [currentPage, setCurrentPage] = useState("dataPage");

    return (
        <>
            <Header currentPage={currentPage} setCurrentPage={setCurrentPage} />
            <DataContainer oktaAuth={props.oktaAuth}/>
            <Footer name={applicationName} version={packageJson.version} company={packageJson.company} />

            <CareCheckIn />
        </>);
}